module.exports = __webpack_public_path__ + "static/img/012酒庄官网3.667ec37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/012酒庄官网3.jpg
// module id = VMd4
// module chunks = 0